import { useEffect, useRef } from 'react';

// Keep background requests out of hidden tabs and avoid overlapping requests.
const usePolling = (callback, enabled, intervalMs = 60000) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!enabled || typeof document === 'undefined') {
      return undefined;
    }

    let inFlight = false;
    let lastStartedAt = Date.now();
    let active = true;

    const poll = (force = false) => {
      if (!active || document.hidden || inFlight || (!force && Date.now() - lastStartedAt < intervalMs)) {
        return;
      }

      inFlight = true;
      lastStartedAt = Date.now();
      Promise.resolve()
        .then(() => callbackRef.current())
        .catch(() => {
          // A failed background request can be retried on the next interval.
        })
        .then(() => {
          inFlight = false;
        });
    };

    const onVisibilityChange = () => {
      if (!document.hidden) {
        poll(true);
      }
    };

    const timer = window.setInterval(poll, intervalMs);
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('focus', poll);

    return () => {
      active = false;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('focus', poll);
    };
  }, [enabled, intervalMs]);
};

export default usePolling;
